var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "boss-jobtype-details-item" }, [
    _c("label", { staticClass: "boss-label pega-input" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.checkValue,
            expression: "checkValue",
          },
        ],
        staticClass: "boss-input-check",
        attrs: { type: "checkbox" },
        domProps: {
          checked: Array.isArray(_vm.checkValue)
            ? _vm._i(_vm.checkValue, null) > -1
            : _vm.checkValue,
        },
        on: {
          change: function ($event) {
            var $$a = _vm.checkValue,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.checkValue = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.checkValue = $$a
                    .slice(0, $$i)
                    .concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.checkValue = $$c
            }
          },
        },
      }),
      _vm._v(_vm._s(_vm.categoryItem.name)),
    ]),
    _vm._v(" "),
    _vm.experienceRangeOptions.length
      ? _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.experienceValue,
                expression: "experienceValue",
              },
            ],
            staticClass: "boss-input-select pega-width-94",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.experienceValue = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          _vm._l(_vm.experienceRangeOptions, function (option, index) {
            return _c(
              "option",
              {
                key: index,
                attrs: { "data-test": "option-" + index },
                domProps: { value: option.id },
              },
              [_vm._v("\n      " + _vm._s(option.name) + "\n    ")]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }